/**
 * Fiyat paketleri — tek kaynak. Fiyatlar sayfası (client/src/pages/Prices.tsx) ve sunucunun
 * /fiyatlar SSR çıktısı (server/seo/render.ts) aynı veriyi kullanır; böylece arama motorlarına ve
 * yapay zeka tarayıcılarına giden HTML ile ziyaretçinin gördüğü fiyatlar ayrışmaz.
 * 3 aylık paket (Başlangıç / Pro Büyüme / Profesyonel Full) + tek seferlik Shopify & ikas
 * Kurulum Paketi (teslim süresi dahil) + fiyatlar sayfasının kendi SSS'i. Tüm fiyatlar KDV hariçtir.
 */

export interface HizmetGrubu {
  baslik: string;
  maddeler: string[];
}

export interface Paket {
  id: string;
  ad: string;
  slogan: string;
  fiyat: number;
  populer?: boolean;
  ekNot?: string;
  gruplar: HizmetGrubu[];
}

export const PAKETLER: Paket[] = [
  {
    id: "baslangic",
    ad: "BAŞLANGIÇ",
    slogan: "Performans reklamcılığına güçlü bir başlangıç yapın",
    fiyat: 34900,
    gruplar: [
      {
        baslik: "DİJİTAL REKLAM YÖNETİMİ",
        maddeler: [
          "Meta (Facebook & Instagram) reklam yönetimi",
          "Google Ads (Arama + Alışveriş) yönetimi",
          "Kampanya kurulumu ve haftalık optimizasyon",
          "Dinamik yeniden pazarlama (katalog reklamları)",
          "Marj bazlı ROAS hedefi ve aylık bütçe planı",
        ],
      },
      {
        baslik: "ÖLÇÜMLEME & TEKNİK",
        maddeler: [
          "Meta Pixel + Conversions API kurulumu ve sağlık takibi",
          "Google Analytics 4 e-ticaret ölçümlemesi",
          "Ürün feed'i (katalog) kurulumu ve yönetimi",
        ],
      },
      {
        baslik: "TASARIM & İÇERİK",
        maddeler: [
          "Aylık 8 kampanya görseli tasarımı",
          "Reklam metni yazımı ve A/B varyantları",
        ],
      },
      {
        baslik: "DANIŞMANLIK & İLETİŞİM",
        maddeler: [
          "Kampanya & indirim kurgusu danışmanlığı",
          "Rakip ve pazar analizi",
          "WhatsApp destek hattı (hafta içi 09.00-18.00)",
          "Ayda 2 online toplantı",
          "Aylık performans raporu",
        ],
      },
    ],
  },
  {
    id: "pro-buyume",
    ad: "PRO BÜYÜME",
    slogan: "Ölçeklenmek isteyen markanın tam kadro dijital ekibi",
    fiyat: 54900,
    populer: true,
    ekNot: "Başlangıç paketindeki tüm hizmetlere ek olarak:",
    gruplar: [
      {
        baslik: "REKLAM & OTOMASYON",
        maddeler: [
          "TikTok reklam yönetimi",
          "YouTube video reklamları",
          "E-posta & SMS pazarlama kurguları",
          "Sepet terk kurtarma otomasyonları",
        ],
      },
      {
        baslik: "UGC & KREATİF",
        maddeler: [
          "Aylık 1 UGC video (senaryo + profesyonel edit)",
          "Aylık 12 kampanya görseli tasarımı",
          "Satış odaklı video danışmanlığı",
        ],
      },
      {
        baslik: "SİTE & DÖNÜŞÜM (CRO)",
        maddeler: [
          "UI/UX analizi ve dönüşüm oranı önerileri",
          "Kampanya landing sayfası kurgusu",
          "E-ticaret sitesi teknik destek hizmeti",
          "Site içi SEO temel optimizasyonu",
        ],
      },
      {
        baslik: "İLETİŞİM",
        maddeler: [
          "Sınırsız online toplantı",
          "Öncelikli WhatsApp desteği",
        ],
      },
    ],
  },
  {
    id: "profesyonel-full",
    ad: "PROFESYONEL FULL",
    slogan: "360° büyüme ortaklığı — ihtiyacınız olan her şey",
    fiyat: 89000,
    ekNot: "Pro Büyüme paketindeki tüm hizmetlere ek olarak:",
    gruplar: [
      {
        baslik: "360° KANAL YÖNETİMİ",
        maddeler: [
          "Tüm kanallarda reklam yönetimi (Meta, Google, TikTok, YouTube, Pinterest, LinkedIn)",
          "Programatik & remarketing ağları danışmanlığı (Criteo, RTB House)",
          "Pazaryeri reklam danışmanlığı (Trendyol, Hepsiburada)",
        ],
      },
      {
        baslik: "SEO & GEO",
        maddeler: [
          "Kapsamlı SEO yönetimi (teknik + içerik + otorite)",
          "GEO: ChatGPT ve yapay zeka asistanlarında görünürlük çalışması",
          "Aylık 4 SEO blog içeriği üretimi",
        ],
      },
      {
        baslik: "UGC & İÇERİK ÜRETİMİ",
        maddeler: [
          "Aylık 1 UGC video + markaya özel içerik üreticisi eşleştirme",
          "Sınırsız kampanya görseli tasarımı",
        ],
      },
      {
        baslik: "E-İHRACAT",
        maddeler: [
          "E-ihracata hazırlık ve yurt dışı pazar danışmanlığı",
          "Yurt dışı kargo ve ödeme altyapısı yönlendirmesi",
        ],
      },
      {
        baslik: "ÖZEL YÖNETİM",
        maddeler: [
          "Size özel müşteri temsilcisi",
          "7/24 WhatsApp hızlı destek hattı",
          "Fiziksel toplantı (İstanbul)",
          "Yıllık büyüme yol haritası",
          "Aylık ROAS ve kârlılık raporu",
        ],
      },
    ],
  },
];

export const KURULUM_GRUPLARI: HizmetGrubu[] = [
  {
    baslik: "1 · ALTYAPI & MAĞAZA AÇILIŞI",
    maddeler: [
      "Shopify veya ikas mağaza açılışı ve tüm temel ayarlar",
      "Alan adı (domain) bağlama ve SSL kurulumu",
      "Kurumsal e-posta yönlendirmeleri",
      "Vergi, para birimi ve bölge ayarları",
    ],
  },
  {
    baslik: "2 · TEMA & TASARIM",
    maddeler: [
      "Markanıza uygun premium tema seçimi ve kurulumu",
      "Ana sayfa, koleksiyon ve ürün sayfası tasarım düzenlemeleri",
      "Marka renk paleti ve tipografi uyarlaması",
      "Mobil uyumluluk ve hız optimizasyonu",
    ],
  },
  {
    baslik: "3 · ÜRÜN & KATALOG",
    maddeler: [
      "50 ürüne kadar ürün yükleme (varyant, beden, renk yapısıyla)",
      "Koleksiyon mimarisi ve menü kurgusu",
      "Ürün başlığı ve açıklamaları için SEO şablonları",
    ],
  },
  {
    baslik: "4 · ÖDEME & OPERASYON",
    maddeler: [
      "Sanal POS / ödeme altyapısı entegrasyonu (iyzico, PayTR vb.)",
      "Kargo firması entegrasyonları ve kargo kuralları",
      "E-fatura entegrasyonu",
      "Mesafeli satış, iade-değişim ve KVKK sayfalarının hazırlanması",
    ],
  },
  {
    baslik: "5 · PAZARLAMA ALTYAPISI",
    maddeler: [
      "Meta Pixel + Conversions API kurulumu",
      "Google Analytics 4 + Search Console bağlantısı",
      "Ürün feed'i: Meta Katalog + Google Merchant Center",
      "E-posta pazarlama altyapısı bağlantısı",
      "WhatsApp iletişim butonu",
    ],
  },
  {
    baslik: "6 · TESLİM & EĞİTİM",
    maddeler: [
      "Yayın öncesi 40+ maddelik kalite kontrol listesi",
      "Panel kullanım eğitimi (kayıtlı video ile)",
      "Teslim sonrası 30 gün ücretsiz teknik destek",
    ],
  },
];

/** Tek seferlik Shopify & ikas E-Ticaret Kurulum Paketi fiyatı (KDV hariç) */
export const KURULUM_FIYAT = 40000;

/**
 * Kurulum paketinin ortalama teslim süresi (işletme kararı K2: Shopify/ikas mağaza kurulumu ortalama 2-4 hafta; ürün/varyant
 * sayısı, entegrasyon ve veri aktarımına göre uzayabilir). Prices.tsx ve SSR /fiyatlar aynı metni basar.
 */
export const KURULUM_TESLIM_SURESI = "2-4 hafta";
export const KURULUM_TESLIM = `Ortalama teslim: ${KURULUM_TESLIM_SURESI}`;
export const KURULUM_TESLIM_NOTU = "Ürün ve varyant sayısı, entegrasyon kapsamı ve veri aktarımı bu süreyi uzatabilir.";

/** Fiyatlar sayfasının kendi SSS'i. `baglanti.metin`, cevap metninin içinde geçen ve bağlantıya dönüşen parçadır. */
export interface FiyatSssMaddesi {
  q: string;
  a: string;
  baglanti?: { metin: string; href: string };
}

export const FIYAT_SSS_BASLIK = "Fiyatlandırma Hakkında Sık Sorulan Sorular";

/**
 * Prices.tsx ve SSR /fiyatlar bu soruları görünür basar; FAQPage'e eklenmez. /fiyatlar'ın FAQPage'i ek içerikten
 * (client/src/lib/ek_icerik/statik_a.ts) gelir ve sayfada tek kalır; buradaki konuların bir kısmı /sss'te işaretli
 * olduğundan (reklam bütçesi, sözleşme süresi, paket seçimi) ikinci kez işaretlenmez.
 * Sözleşme cevabı işletme kararları K1 ve K5'tir (HizmetSozlesmesi.tsx madde 3 ve 8.3, IptalIade.tsx madde 4 ile aynı kural):
 * en az 3 ay taahhüt, sonrası aylık; 3 ay dolmadan haklı neden olmaksızın ayrılmada kalan ayların bedeli tahsil edilir.
 */
export const FIYAT_SSS: FiyatSssMaddesi[] = [
  {
    q: "Paket fiyatlarına reklam bütçeleri dahil midir?",
    a: "Hayır, paket fiyatlarımız Dijipo'nun profesyonel yönetim, kreatif üretim, optimizasyon ve danışmanlık hizmet bedelidir. Reklam bütçeleri (Meta, Google vb.) doğrudan sizin kredi kartınızdan çekilir ve hesaplar sizin varlığınız olarak kalır.",
  },
  {
    q: "Fiyatlara KDV dahil mi?",
    a: "Sayfadaki tüm fiyatlar KDV hariçtir; faturalandırma güncel KDV oranı eklenerek yapılır. Tüm hizmetlerimiz kurumsal fatura ile belgelenir.",
  },
  {
    q: "Sözleşme süresi ne kadardır?",
    a: "Aylık büyüme paketlerinde en az 3 ay taahhüt vardır; sonrasında çalışma aylık devam eder. İlk 3 aydan sonra hizmeti dönem bitiminden en az 30 gün önce yazılı bildirimle (e-posta yeterlidir) sonlandırabilirsiniz; paket değişikliği bir sonraki fatura döneminden geçerli olur. İlk 3 ay dolmadan haklı bir neden olmaksızın ayrılırsanız taahhüdün kalan aylarının hizmet bedeli tahsil edilir. Kurulum paketi tek seferliktir ve bu taahhüde tabi değildir.",
  },
  {
    q: "Hangi paket bana uygun, nasıl karar veririm?",
    a: "Aylık reklam bütçeniz 100.000 TL'nin altındaysa Başlangıç, ölçeklenme dönemindeyseniz ve içerik/UGC ihtiyacınız varsa Pro Büyüme, çok kanallı tam ekip yönetimi istiyorsanız Profesyonel Full doğru tercihtir. Emin değilseniz ücretsiz ön görüşmede hesabınıza bakıp birlikte karar veriyoruz.",
    baglanti: { metin: "ücretsiz ön görüşmede", href: "/randevu" },
  },
];

/** Cevabı bağlantı öncesi / bağlantı metni / bağlantı sonrası parçalarına ayırır (React ve SSR aynı metni basar). */
export function fiyatSssParcalari(s: FiyatSssMaddesi): { once: string; baglanti?: { metin: string; href: string }; sonra: string } {
  if (!s.baglanti) return { once: s.a, sonra: "" };
  const i = s.a.indexOf(s.baglanti.metin);
  if (i < 0) return { once: s.a, sonra: "" };
  return { once: s.a.slice(0, i), baglanti: s.baglanti, sonra: s.a.slice(i + s.baglanti.metin.length) };
}

/** Paket adının başlık biçimi (ör. "PRO BÜYÜME" → "Pro Büyüme") */
export const paketAdi = (p: Paket) =>
  p.ad.toLocaleLowerCase("tr-TR").replace(/(^|\s)(\S)/g, (_, b: string, h: string) => b + h.toLocaleUpperCase("tr-TR"));
